import { inject, Injectable } from '@angular/core';
import { GungLanguageConfigService } from 'gung-common';
import { FashionLoginComponent } from '../../components/login/fashion-login/fashion-login.component';
import { NavbarLoginComponent } from '../../components/login/navbar-login/navbar-login.component';
import { BaseViewConfigService } from '../base-view-config/base-view-config.service';

@Injectable({
  providedIn: 'root'
})
export class LoginConfigService {
  protected baseViewConfigService = inject(BaseViewConfigService);
  protected languageConfigService = inject(GungLanguageConfigService);

  showRequestAccount() {
    return this.baseViewConfigService.showRequestAccountLogin;
  }

  getLoginType(): LoginType {
    return undefined;
  }

  getLoginComponent(loginType?) {
    switch (this.getLoginType()) {
      case LoginType.FashionLogin:
        return FashionLoginComponent;
      case LoginType.NavbarLogin:
        return NavbarLoginComponent;
      default:
        return this.baseViewConfigService.getLoginComponent(loginType);
    }
  }

  getVideoBackground(): string {
    return undefined;
  }

  getShowLanguageDropDown(): boolean {
    return this.languageConfigService.showLanguageDropDownLogin;
  }

  getShowInTabsEnabled(): boolean {
    return false;
  }
}

export enum LoginType {
  FashionLogin,
  NavbarLogin,
  default
}
